<template>
  <div :class="{'do-calendar__header': activeCalendarDate}">
    <div class="d-cal__header text-dark">
      <div class="d-cal__header__left">
        <DCalendarSelect
          v-if="userHasPermission('can_see_other_calendars')"
          :calendar="calendar">
        </DCalendarSelect>
        <h2 v-else>{{ calendarName }}</h2>
        <template v-if="activeCalendarDate">
          <div class="do-button__multiple no-print">
            <button :content="tooltipArrowLeft"
                    v-tippy="{
                 placement: 'bottom',
                 zIndex: 1212121212,
                 onShow: () => hasHotKeys
               }" class="do-button__multiple__bttn icon-arrow-left4 no-print" @click="$emit('prev')"></button>
            <button class="no-print do-button__multiple__bttn"
                    @click="$emit('today')"
                    :class="{'bttn--disabled': isToday}">
              {{ $t('repitition.today') }}
            </button>
            <button :content="tooltipArrowRight"
                    v-tippy="{
                 placement: 'bottom',
                 zIndex: 1212121212,
                 onShow: () => hasHotKeys
               }" class="do-button__multiple__bttn icon-arrow-right4 " @click="$emit('next')"></button>
          </div>
        </template>
        <h3 class="do-calendar__date" v-if="dates">{{ calendarDateInterval }}</h3>
        <div class="do-spinner" v-if="isLoadingEvents"></div>
      </div>
      <div class="d-cal__header__right no-print">
        <button :class="{'do-bttn': activeCalendarDate}" v-if="isMergeCalendar" @click="setIsShowMergeCalendars(true)">
          {{ $t('vue2.editCalendarMenu.merge_with_calendar') }}
        </button>
        <button class="do-bttn"
                v-if="userCanRequestAbsence"
                @click="isShowAbsenceRequest = true"
        >
          {{ $t('vue2.request_absence.request_absence') }}
        </button>
        <UserPresence
          :calid="calendarId"
          :firstDayOfTheWeek="firstDayOfTheWeek"
          :activeCalendarDate="activeCalendarDate"
          :isModalLeft="true"
          @saved="$emit('updateEvents')"
          v-if="canEditPresence">
        </UserPresence>
        <div class="do-calculate-hours" v-if="activeCalendarDate">
          <button class="do-bttn" @click="isShowCalculateHours = !isShowCalculateHours">{{ i18n['calculate_hours'] }}
            <span class="icon-arrow-down5"></span></button>
          <transition name="fadeInDown">
            <div class="do-calculate-hours__dropdown" v-if="isShowCalculateHours">
              <div class="do-calculate-hours__dropdown__header" @click="isShowCalculateHours = false">
                <div class="icon__bg-circle"><span class="icon-cross2"></span></div>
              </div>
              <CalculateHours
                :schoolId="schoolId"
                :calendarId="calendarId"
                :date="activeCalendarDate">
              </CalculateHours>
            </div>
          </transition>
        </div>
        <CopyCalendar
          :calid="calendarId"
          :calendarType="calendarType"
          :activeCalendarDate="activeCalendarDate"
          :initCalendar="initCalendar"
          @copyCalendarModalOpen="$emit('copyCalendarModalOpen', $event)">
        </CopyCalendar>
        <Print
          :calendarId="calendarId"
          :activeCalendarDate="activeCalendarDate">
        </Print>
        <DCalendarHeaderDelete
          v-if="activeCalendarDate"
          :calendarId="calendarId"
          :firstDayOfTheWeek="firstDayOfTheWeek"
          :date="activeCalendarDate"
          @update="$emit('updateCalendar')"
        >
        </DCalendarHeaderDelete>
        <DDropdown :isShowDots="false" :isBottomStart="false" :propOffset="[5, 5]">
          <button slot="title" :class="{'do-bttn': activeCalendarDate}"><span class="icon-more2"></span></button>
          <ul slot="list">
            <li @click="toggleCalendarLock" v-if="canBeLocked">
              <template v-if="isLocked">
                <span class="icon-lock5"></span> {{ $t('vue2.editCalendarMenu.unlock') }}
              </template>
              <template v-else>
                {{ $t('vue2.editCalendarMenu.lock') }}
              </template>
            </li>
            <li @click="openPublicCalendar" v-if="canSeePublicCalendar">
              <template v-if="isAnonymousAccessActivated">
                {{ $t('vue2.editCalendarMenu.see_public_view') }}
              </template>
              <template v-else>
                {{ $t('vue2.editCalendarMenu.active_public_view') }}
              </template>
            </li>
            <li @click="setIsShowMergeCalendars(true)"
                v-if="canSeeMergeWithMergeCalendars">
              {{ $t('vue2.editCalendarMenu.merge_with_merge_calendars') }}
            </li>
            <li v-if="canSeeExportCalendar" @click="setIsShowExportCalendarModal(true)">
              {{ $t('vue2.calendar_export.export_calendar') }}
            </li>
            <li v-if="canToggleViewState">
              <span class="icon-arrow-left4"></span> {{ $t('vue2.editCalendarMenu.view') }}
              <ul>
                <li @click="toggleCalendarView(0)">{{ $t('vue2.editCalendarMenu.5_days') }}</li>
                <li @click="toggleCalendarView(1)">{{ $t('vue2.editCalendarMenu.7_days') }}</li>
                <li @click="toggleCalendarView(2)">{{ $t('vue2.editCalendarMenu.7_days_and_24_hours') }}</li>
              </ul>
            </li>
            <li @click="openEditNameModal" v-if="canEditName">
              <span class="icon-pencil"></span>
              {{ $t('vue2.editCalendarMenu.edit_name') }}
            </li>
            <li v-if="canBeDeleted" class="d-item-warning" @click="openDeleteModal"><span class="icon-bin"></span>
              {{ $t('vue2.editCalendarMenu.delete_calendar') }}
            </li>
            <li v-if="canBeArchived" class="d-item-warning" @click="archiveCalendar">
              <span class="icon-bin"></span> {{ $t('vue2.editCalendarMenu.remove_calendar') }}
            </li>
          </ul>
        </DDropdown>
        <div v-if="isLocked" :content="$t('vue2.editCalendarMenu.calendar_is_locked')"
             v-tippy="{arrow: true,placement : 'left'}">
          <div class="d-cal__header__right__lock icon__bg-circle" @click="toggleCalendarLock" v-if="true">
            <span class="icon-lock5"></span>
          </div>
          <div class="d-cal__header__right__lock" v-else>
            <span class="icon-lock5"></span>
          </div>
        </div>
      </div>
    </div>
    <EditCalendarEditName
      v-if="calendar"
      :calendar="calendar">
    </EditCalendarEditName>
    <EditCalendarDelete
      v-if="calendar"
      :calendar="calendar">
    </EditCalendarDelete>
    <ExportCalendar
      :isShowButton="false"
      :isShowFromProp="isShowExportCalendarModal"
      :calLink="iCalUrl"
      @close="setIsShowExportCalendarModal(false)">
    </ExportCalendar>
    <CalendarMergeModal
      v-if="isShowMergeCalendars"
      :schoolId="schoolId"
      :calendarId="calendarId"
      :calendar="calendar"
      @close="setIsShowMergeCalendars(false)">
    </CalendarMergeModal>
    <div class="bg-overlay do-datepicker__dropdown__overlay" v-if="isShowCalculateHours"
         @click.stop.self="isShowCalculateHours = false"></div>
    <UserRequest v-if="isShowAbsenceRequest"
                 @close="isShowAbsenceRequest = false">
    </UserRequest>
  </div>
</template>

<script>
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import DCalendarSelect from './DCalendarSelect'
import CopyCalendar from '../CopyCalendar/CopyCalendar'
import Print from '../PrintCalendars/Print'
import DDropdown from '../common/DDropdown'
import EditCalendarEditName from '../EditCalendars/EditCalendarEditName'
import EditCalendarDelete from '../EditCalendars/EditCalendarDelete'
import UserPresence from '../Presence/User/PresenceUser'
import ExportCalendar from '../ExportCalendar/ExportCalendar'
import moment from 'moment'
import CalendarMergeModal from '../Calendars/CalendarMergeModal'
import CalculateHours from '../Calendars/CalculateHours'
import DCalendarHeaderDelete from './DCalendarHeaderDelete'
import UserRequest from '../UserRequests/UserRequest.vue'

const I18N = {
  da: {
    calculate_hours: 'Beregn timer'
  },
  en: {
    calculate_hours: 'Calculate Hours'
  },
  nb: {
    calculate_hours: 'Beregn timer'
  }
}

export default {
  components: {
    UserRequest,
    DCalendarHeaderDelete,
    CalculateHours,
    CalendarMergeModal,
    EditCalendarDelete,
    ExportCalendar,
    EditCalendarEditName, DDropdown, Print, DCalendarSelect, CopyCalendar, UserPresence
  },
  props: {
    calendarId: {
      required: true
    },
    initCalendar: {
      default: null
    },
    activeCalendarDate: {
      default: null
    },
    dates: {
      default: null
    },
    hasHotKeys: {
      default: false
    },
    isLoadingEvents: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      calendar: null,
      isShowExportCalendarModal: false,
      isShowMergeCalendars: false,
      isShowCalculateHours: false,
      isShowAbsenceRequest: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    schoolFeatures () {
      return this.$store.getters.schoolFeatures
    },
    isOwnCalendar () {
      return this.user && this.user.user_calendar_id === this.calendarId
    },
    absenceRequestIsActivated () {
      return this.schoolFeatures.indexOf('absence_requests') > -1
    },
    userCanRequestAbsence () {
      return this.isOwnCalendar && this.absenceRequestIsActivated && this.userHasPermission('can_request_absence')
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    calendarType () {
      return this.calendar && this.calendar.type ? this.calendar.type : null
    },
    isMergeCalendar () {
      return this.calendarType === 'merge'
    },
    calendarName () {
      return this.calendar && this.calendar.name ? this.calendar.name : ''
    },
    iCalUrl () {
      return this.calendar && this.calendar.ical_url ? window.location.origin + this.calendar.ical_url : this.calendar && this.calendar.ical_link ? window.location.origin + this.calendar.ical_link : 'loading'
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    schoolId () {
      return this.calendar && this.calendar.school_id ? this.calendar.school_id : this.activeSchool.id
    },
    firstDayOfTheWeek () {
      return this.$store.getters.firstDayOfTheWeek
    },
    isLocked () {
      return this.calendar && this.calendar.locked ? this.calendar.locked : false
    },
    canBeLocked () {
      const typesThatCantBeLocked = ['user', 'room']
      return typesThatCantBeLocked.indexOf(this.calendarType) < 0 && this.userHasPermission('can_do_most_stuff')
    },
    canToggleViewState () {
      return this.userHasPermission('can_do_most_stuff')
    },
    canBeDeleted () {
      const typesThatCantBeDeleted = ['merge', 'room', 'user']
      return typesThatCantBeDeleted.indexOf(this.calendarType) < 0 && this.userHasPermission('can_manage_calendars')
    },
    canEditName () {
      const typesThatCantEditName = ['user']
      return typesThatCantEditName.indexOf(this.calendarType) < 0 && this.userHasPermission('can_manage_calendars')
    },
    canBeArchived () {
      const typesThatCantBeDeleted = ['merge', 'room']
      return typesThatCantBeDeleted.indexOf(this.calendarType) > -1 && this.userHasPermission('can_manage_calendars')
    },
    canEditPresence () {
      // Permission is in the component
      const typesThatCanEditPresence = ['user']
      return typesThatCanEditPresence.indexOf(this.calendarType) > -1
    },
    canSeeExportCalendar () {
      const typesThatCanExportCalendar = ['user']
      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1
    },
    canSeeMergeWithMergeCalendars () {
      const typesThatCanExportCalendar = ['klass', 'club']
      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    isToday () {
      return this.activeCalendarDate ? moment(this.activeCalendarDate).isoWeek() === moment().isoWeek() : false
    },
    calendarDateInterval () {
      if (this.dates.length === 0) {
        return ''
      }
      const startDate = moment(this.dates[0])
      const endDate = moment(this.dates[this.dates.length - 1])
      let startFormat = startDate.format('D.')
      if (!moment(startDate).isSame(endDate, 'month')) {
        startFormat = startDate.format('D. MMM')
      }
      if (!moment(startDate).isSame(endDate, 'year')) {
        startFormat = startDate.format('D. MMM, YYYY')
      }
      const endFormat = endDate.format('D. MMM, YYYY')
      return `${startFormat} - ${endFormat}`
    },
    tooltipArrowLeft () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>←</span></p>'
    },
    tooltipArrowRight () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span><span>→</span></p>'
    },
    metaKey () {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return isMac ? '⌘' : 'CTRL'
    },
    isAnonymousAccessActivated () {
      return this.calendar && this.calendar.anonymous_access
    },
    canSeePublicCalendar () {
      const typesThatCanExportCalendar = ['klass', 'kindergarten']
      return typesThatCanExportCalendar.indexOf(this.calendarType) > -1
    }
  },
  methods: {
    setIsShowMergeCalendars (bool) {
      this.isShowMergeCalendars = bool
      if (!bool) {
        if (this.activeCalendarDate) {
          this.$emit('updateEvents')
        } else {
          // For ROR
          window.location.reload()
        }
      }
    },
    setIsShowExportCalendarModal (bool) {
      this.isShowExportCalendarModal = bool
    },
    userHasPermission (permission, notAdmin = false) {
      if (!this.user) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        if (notAdmin) {
          return this.userPermissions.indexOf(permission) > -1
        }
        return this.userPermissions.indexOf(permission) > -1 || this.user.admin
      }
      return true
    },
    openEditNameModal () {
      eventbus.editCalendarNameModal = true
    },
    openDeleteModal () {
      eventbus.editCalendarDeleteModal = true
    },
    toggleCalendarLock () {
      const bool = this.isLocked ? 'false' : 'true'
      this.updateCalendar({locked: bool})
    },
    toggleCalendarView (state) {
      this.updateCalendar({view_state: state})
    },
    updateCalendar (changesObj) {
      docendo.schoolCalendarsUpdate(this.schoolId, this.calendarId, changesObj, success => {
        eventbus.toast = {text: 'Calendar updated', 'success': true}
        window.location.reload()
      }, failure => {
        console.log({failure})
      })
    },
    archiveCalendar () {
      docendo.schoolCalendarsUpdate(this.schoolId, this.calendarId, {archived: true}, success => {
        let updateObj = {
          id: success.id,
          name: success.name,
          archived_at: success.archived_at
        }
        this.$store.commit('updateSchoolCalendar', updateObj)
        eventbus.toast = {text: 'Calendar updated', 'success': true}
        window.location.href = '/calendar'
      }, failure => {
        console.log('failure', failure)
      })
    },
    openPublicCalendar () {
      if (this.calendar.anonymous_access) {
        const url = this.generatePublicLink(this.calendar)
        window.open(url, '_blank').focus()
      } else {
        const schoolId = this.calendar.school_id ? this.calendar.school_id : this.schoolId
        const url = window.location.origin + '/schools/' + schoolId + '/calendars_setup#/'
        window.open(url, '_blank').focus()
      }
    },
    generatePublicLink (calendar) {
      return window.location.origin + '/calendar/' + calendar.public_id
    }
  },
  beforeMount () {
    if (this.initCalendar) {
      this.calendar = this.initCalendar
    } else {
      docendo.calendar(this.calendarId, success => {
        this.calendar = success
      }, failure => {
        eventbus.toast = {text: 'Something went wrong', 'success': false}
      })
    }
  }
}
</script>

<style scoped>

.d-cal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-cal__header__left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.d-cal__header__right {
  display: flex;
  gap: 0.5rem;
}

.d-cal__header__left__presence {
  margin-left: 2rem;
}

.d-cal__header__right__lock:not(.icon__bg-circle) {
  width: 30px;
  height: 30px;
  font-size: 1rem;
  border-radius: 50%;
  transition: background-color .3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.d-cal__header__right__lock > span {
  margin-top: -1px;
  margin-right: -4px;
}

.do-calendar__date {
  letter-spacing: .075rem;
  font-weight: 700;
  display: block;
  color: #828690;
  margin-left: 1rem;
  font-size: 1.15rem;
}

.do-button__multiple {
  display: flex;
  justify-content: stretch;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, .12) 0px 1px 1px 0px, rgba(64, 68, 82, .16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(64, 68, 82, .08) 0px 2px 5px 0px;
  border: 0;
  background: #fff;
  font-weight: 600;
  letter-spacing: .025em;
  border-radius: 4px;
}

.do-button__multiple > .do-button__multiple__bttn {
  text-align: center;
  padding: 2px 10px;
  font-weight: bold !important;
  height: 28px;
  cursor: pointer;
  background: #ffffff;
  border: none;
}

.do-button__multiple > .do-button__multiple__bttn:hover {
  background: #f9fafb;
}

.do-button__multiple > .do-button__multiple__bttn:focus {
  position: relative;
  z-index: 1;
}

.do-button__multiple > .do-button__multiple__bttn:nth-child(2) {
  border: 1px solid #ccc;
  border-radius: 0;
  border-width: 0 1px;
}

.do-button__multiple > .do-button__multiple__bttn.bttn--disabled {
  cursor: not-allowed;
}

.do-calculate-hours {
  position: relative;
}

.do-calculate-hours__dropdown {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  z-index: 123101;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .21);
  border-radius: 4px;
  min-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.do-calculate-hours__dropdown__header {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  opacity: 0.5;
}

.do-datepicker__dropdown__overlay {
  background: transparent;
  z-index: 123100;
}

</style>



// WEBPACK FOOTER //
// DCalendarHeader.vue?21226106